import React from 'react'
import PropTypes from 'prop-types'

import SkillButton from '../../leevo_ui/SkillButton/SkillButton'

function SkillLevelList({ skillLevels = [], selectedCategory }) {
  function filteredSkills(skills) {
    return skills
      .sort((a, b) => a.ordinal - b.ordinal)
      .filter((skill) => !selectedCategory || selectedCategory === skill.category)
  }

  function skillButtons(skills) {
    const filtered = filteredSkills(skills)

    if (!filtered.length) {
      return <p className="text-sm text-gray-500 py-2">No skills configured for this level</p>
    }

    return filtered.map((skill) => (
      <div key={skill.shortLabel} className="flex items-center py-2">
        <SkillButton label={skill.shortLabel} state="neutral" />
        <div className="pl-2 text-gray-900 dark:text-gray-900">{skill.name}</div>
      </div>
    ))
  }

  if (!skillLevels.length) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-sm text-gray-500">No skill levels for this class</p>
      </div>
    )
  }

  return skillLevels.map((skillLevel) => (
    <div key={skillLevel.id} className="overflow-hidden mb-3 border border-gray-200 rounded-lg">
      <h2 className="p-5 border-b border-gray-200 text-purple-800 font-medium bg-purple-100">
        {skillLevel.name} {selectedCategory && ` - ${selectedCategory}`}
      </h2>
      <div className="flex bg-white flex-col justify-center p-3" style={{ breakInside: 'avoid' }}>
        {skillButtons(skillLevel.skills)}
      </div>
    </div>
  ))
}

SkillLevelList.propTypes = {
  skillLevels: PropTypes.array,
  selectedCategory: PropTypes.string
}
export default SkillLevelList
